import { type EventFilter } from "@package/ui-gql/index-analytics";
import { useGetPostListNameIdQuery } from "@package/ui-gql/index-data-access";
import { type WritableDraft } from "immer";
import { uniq } from "lodash";
import { useMemo, useState } from "react";
import { useItemGridFilterContext } from "../ItemGridFilter/context-item-grid-filter";
import {
  ItemGridFilterDataList,
  type FilterValueEntry,
} from "../ItemGridFilter/ItemGridFilterDataList";

type SupportedFilter = EventFilter | null | undefined;

export function ItemGridFilterPosts() {
  const [query, setQuery] = useState<string>("");

  const { filter, updateFilterState } = useItemGridFilterContext();
  const { data, loading, error } = useGetPostListNameIdQuery({
    variables: {
      page: 0,
      perPage: 1000,
      sortField: "title",
      sortOrder: "ASC",
      filter: (query && { q: query }) || undefined,
    },
  });

  const filterWithPosts: SupportedFilter = filter;
  const items = useMemo<FilterValueEntry[]>(() => {
    const values: FilterValueEntry[] =
      data?.items
        ?.slice()
        ?.filter((item) => !!item?.id)
        ?.map((item) => {
          const id = item.id ?? "";
          const name = item.title ?? "";
          const checked = filterWithPosts?.post?.includes(id) ?? false;
          return {
            id,
            name,
            checked,
          };
        }) ?? [];

    return values;
  }, [data?.items, filterWithPosts?.post]);

  return (
    <ItemGridFilterDataList
      error={error}
      items={items}
      loading={loading}
      property="post"
      text="Content"
      onQueryValueChanged={setQuery}
      onRequestFilterReset={() =>
        updateFilterState((draft: WritableDraft<SupportedFilter>) => {
          if (draft) {
            delete draft.post;
          }
        })
      }
      onRequestFilterUpdate={(id, include) =>
        updateFilterState((draft: WritableDraft<SupportedFilter>) => {
          if (draft) {
            if (include) {
              draft.post = uniq([...(draft.post ?? []), id]);
            } else if (draft.post?.length) {
              draft.post = draft.post.filter((post) => post !== id);
            }

            if (!draft.post?.length) {
              delete draft.post;
            }
          }
        })
      }
      onSelectAllChanged={(checked) => {
        if (checked) {
          updateFilterState((draft: WritableDraft<SupportedFilter>) => {
            if (draft) {
              draft.post = items.map((item) => item.id);
            }
          });
        } else {
          updateFilterState((draft: WritableDraft<SupportedFilter>) => {
            if (draft) {
              delete draft.post;
            }
          });
        }
      }}
    />
  );
}
